import {
    GA_HOME,
    GA_QUERIES,
    GA_QUERIES_PANEL,
    GA_REPORTS,
    GA_WIRES,
    GA_WIRES_ADMIN,
    GA_TRADECAPTURE_LIST,
    GA_TRADECAPTURE_ENTRY,
    GA_ASSETTRANSFER_ENTRY,
    GA_TRADECAPTURE_UPLOAD,
    GA_TRADECAPTURE_BREAKS,
    GA_MMF,
    GA_SHORTSALE_APPROVAL_PERSIST_DETAILS,
    GA_SHORTSALE_APPROVAL_HISTORY,
    GA_SHORTSALE_APPROVAL_LOCATE,
    GA_SHORTSALE_APPROVAL_UPLOAD,
    GA_SHORTSALE_APPROVAL_SEARCH,
    GA_SHORTSALE_APPROVAL_PASTE_FROM_CLIPBOARD,
    GA_PROFILE,
    GA_CHANGE_PASSWORD,
    GA_CHANGE_PASSWORD_SUCCESS,
    GA_LOGIN,
    GA_LOGOUT, GA_UNKNOWN
} from './GAConstants';

const pageBusinessMap = {
    [GA_HOME]: 'Dashboard Overview',
    [GA_QUERIES]: 'Queries Management',
    [GA_QUERIES_PANEL]: 'Queries Panel',
    [GA_REPORTS]: 'Reports Management',
    [GA_WIRES]: 'Wire Transfers Management',
    [GA_WIRES_ADMIN]: 'Wire Transfers Admin Management',
    [GA_TRADECAPTURE_LIST]: 'Trade Capture Management',
    [GA_TRADECAPTURE_ENTRY]: 'Trade Entry Management',
    [GA_ASSETTRANSFER_ENTRY]: 'Assert Transfer Entry Management',
    [GA_TRADECAPTURE_UPLOAD]: 'Trade Upload Management',
    [GA_TRADECAPTURE_BREAKS]: 'Trade Breaks Management',
    [GA_MMF]: 'Money Market Funds Management',
    [GA_SHORTSALE_APPROVAL_PERSIST_DETAILS]: 'Short Sale Approval and Persistence Details',
    [GA_SHORTSALE_APPROVAL_HISTORY]: 'Short Sale Approval History',
    [GA_SHORTSALE_APPROVAL_LOCATE]: 'Short Sale Approval Locate',
    [GA_SHORTSALE_APPROVAL_UPLOAD]: 'Short Sale Approval Upload',
    [GA_SHORTSALE_APPROVAL_SEARCH]: 'Short Sale Approval Search',
    [GA_SHORTSALE_APPROVAL_PASTE_FROM_CLIPBOARD]: 'Short Sale Approval Paste from Clipboard',
    [GA_PROFILE]: 'User Profile Management',
    [GA_CHANGE_PASSWORD]: 'Change Password',
    [GA_CHANGE_PASSWORD_SUCCESS]: 'Change Password Success',
    [GA_LOGIN]: 'User Login',
    [GA_LOGOUT]: 'User Logout',
    [GA_UNKNOWN]: 'Unknown Functionality',
};

function getBusinessFunctionality(pathname) {
    const path = pathname.split('?')[0];
    return pageBusinessMap[path] || pageBusinessMap['GA_UNKNOWN'];
}

export {getBusinessFunctionality, pageBusinessMap};